import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'app/shared-components/util/restAPI';
import { startLoading, stopLoading } from 'app/store/utilSlice';

export const fetchUsageMeters = createAsyncThunk(
  'meters/fetchUsageMeters',
  async ({userId}, { dispatch }) => {
    try {
      dispatch(startLoading());
      const apiName = 'CoreAPI2';
      const path = `/x2/subscriptionstatus/${userId}/usagemeters`;
      const options = { headers: {}, response: false };
      return await apiGet(apiName, path, options);
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const enableOverage = createAsyncThunk(
  'meters/enableOverage',
  async ({meterId, enabled, monthlyBudgetCents}, { dispatch }) => {
    try {
      dispatch(startLoading());
      const apiName = 'CoreAPI2';
      const path = '/x2/stripe/overage';
      const options = {
        body: { meterId, enabled, monthlyBudgetCents },
        headers: {},
        response: false
      };
      const result = await apiPost(apiName, path, options);
      return { meterId, enabled, monthlyBudgetCents, ...result };
    } finally {
      dispatch(stopLoading());
    }
  }
);

const meterSlice = createSlice({
  name: 'meters',
  initialState: {
    usageMeters: [],
    loading: false,
    configureOverageDialogOpen: false,
    selectedMeterId: null,
    error: null
  },
  reducers: {
    openConfigureOverageDialog: (state, action) => {
      state.configureOverageDialogOpen = true;
      state.selectedMeterId = action.payload;
    },
    closeConfigureOverageDialog: (state) => {
      state.configureOverageDialogOpen = false;
      state.selectedMeterId = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUsageMeters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsageMeters.fulfilled, (state, action) => {
        state.usageMeters = action.payload;
        state.loading = false;
      })
      .addCase(fetchUsageMeters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(enableOverage.fulfilled, (state, action) => {
        const index = state.usageMeters.findIndex(
          m => m.meterId === action.payload.meterId
        );
        if (index >= 0) {
          state.usageMeters[index].overageEnabled = action.payload.enabled;
          state.usageMeters[index].monthlyBudgetCents = action.payload.monthlyBudgetCents;
        }
      });
  }
});

export const selectUsageMeters = ({ meters }) => meters.usageMeters;
export const selectMetersLoading = ({ meters }) => meters.loading;
export const selectConfigureOverageDialogOpen = ({ meters }) => meters.configureOverageDialogOpen;
export const selectSelectedMeterId = ({ meters }) => meters.selectedMeterId;
export const selectSelectedMeter = ({ meters }) => {
  if (!meters.selectedMeterId) return null;
  return meters.usageMeters.find(m => m.meterId === meters.selectedMeterId);
};

export const { openConfigureOverageDialog, closeConfigureOverageDialog } = meterSlice.actions;
export default meterSlice.reducer;
